import React from 'react'
import { Notification } from 'is24-corecss'
import { useTranslation } from 'react-i18next'

export function MissingRequiredDataNotification() {
  const { t } = useTranslation()

  return (
    <Notification.Root type='info' size='small' variant='flat'>
      <Notification.Icon />
      <Notification.Content>
        <Notification.Message>
          {t('wizard.screen.basicInfo.price.recommendedNotification.missingRequiredData')}
        </Notification.Message>
      </Notification.Content>
    </Notification.Root>
  )
}
